__turbopack_context__.v({
  "footer": "SomethingWrong-module__VKJf6W__footer",
  "wrapper": "SomethingWrong-module__VKJf6W__wrapper",
});
